import * as Store from './companiesStore';
import { takeEvery, call, put } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import * as api from '../../api/companyApi'
import * as accountApi from '../../api/accountApi'

export function* watchCompaniesSagas() {
    yield takeEvery(Store.ActionType.RequestRegisteredCompanies, fetchCompanies);
    yield takeEvery(Store.ActionType.AcceptCompany, acceptCompany);
    yield takeEvery(Store.ActionType.RejectCompany, rejectCompany);
    yield takeEvery(Store.ActionType.DeleteCompany, deleteCompanyFlow);
    yield takeEvery(Store.ActionType.AdminDeleteUser, adminDeleteUserFlow);
    yield takeEvery(Store.ActionType.CreatePartnerApiKey, createPartnerApiKey);
}

function* fetchCompanies() {
    const companies = yield call(api.fetchRegisteredCompanies);

    yield put(Store.actionCreators.receivedRegisteredCompanies(companies))
}

function* acceptCompany(action: Store.AcceptAction) {
    const result = yield call(api.acceptCompany, action.companyId)

    if (result) {
        yield put(Store.actionCreators.requestRegisteredCompanies());
    }
}

function* rejectCompany(action: Store.RejectAction) {
    const result = yield call(api.rejectCompany, action.companyId)

    if (result) {
        yield put(Store.actionCreators.requestRegisteredCompanies());
    }
}

function* deleteCompanyFlow(action: Store.DeleteCompanyAction){
    yield call(api.deleteCompany, action.companyId);

    yield put(Store.actionCreators.requestRegisteredCompanies());
}

function* adminDeleteUserFlow(action: Store.AdminDeleteUserAction) {
    const success = yield call(accountApi.deleteUser, action.userId);
    
    if (success) {
        yield put(Store.actionCreators.requestRegisteredCompanies());
    }
}

function* createPartnerApiKey(action: Store.CreatePartnerApiKeyAction) {
    const result = yield call(api.createPartnerApiKey, action.companyId);

    if (result) {
        yield put(Store.actionCreators.requestRegisteredCompanies());
    }
}


// WEBPACK FOOTER //
// ./src/admin/store/companiesSagas.ts